import { useState } from "react";

function useProvideAuth() {

  // *For User
  const [user, setUser] = useState(() => {
    // A previously stored avatar can point at "<base>/user_image/<id>/null"
    // (the user has no profile picture). Drop it so the UI falls back to the
    // avatar initial instead of requesting a URL that always 404s.
    const stored = JSON.parse(localStorage.getItem('user'));
    if (stored && typeof stored.image === 'string' && /\/null$/.test(stored.image)) {
      stored.image = undefined;
    }
    return stored;
  });

  // *For Login
  const userLogin = (data) => {
    localStorage.setItem('user', JSON.stringify(data))
    setUser(data)
  };

  // *For User Detail — merges profile data into the existing user object
  const saveUserDetail = (data) => {
    const merged = { ...user, ...data }
    localStorage.setItem('user', JSON.stringify(merged))
    setUser(merged)
  };

  // *For Logout
  const userLogout = async () => {
    setUser(null)
    localStorage.clear()
  };

  return {
    user,
    userLogin,
    userLogout,
    saveUserDetail
  };
}

export default useProvideAuth;
